import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  lineDisplayProfileService,
  LineDisplaySaveError,
  type LineDisplayGridKind,
  type LineDisplayScope,
  type ResolveLineDisplayResponse,
  type SaveLineDisplayRequest,
  type SaveLineDisplayResponse,
} from '../../services/api/lineDisplayProfileService';

// ============================================================================
// Buyer line display profile thunks — Spec buyer-line-display-profile (group 8).
// ============================================================================

/** Resolve the effective columns (+ provenance) for a grid_kind + scope. */
export const resolveLineDisplayProfile = createAsyncThunk<
  ResolveLineDisplayResponse,
  { gridKind: LineDisplayGridKind; scope: LineDisplayScope }
>(
  'lineDisplayProfile/resolve',
  async ({ gridKind, scope }, { rejectWithValue }) => {
    try {
      return await lineDisplayProfileService.resolve(gridKind, scope);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to resolve line display profile');
    }
  }
);

/**
 * Save (create/supersede) the column overrides at a scope. On BE validation
 * failure the rejected payload is the `messages[]` array so the page can render
 * each server-side error verbatim.
 */
export const saveLineDisplayProfile = createAsyncThunk<
  SaveLineDisplayResponse,
  SaveLineDisplayRequest,
  { rejectValue: string[] }
>(
  'lineDisplayProfile/save',
  async (request, { rejectWithValue }) => {
    try {
      return await lineDisplayProfileService.save(request);
    } catch (error: unknown) {
      if (error instanceof LineDisplaySaveError) {
        return rejectWithValue(error.messages);
      }
      return rejectWithValue([error instanceof Error ? error.message : 'Failed to save line display profile']);
    }
  }
);
